import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Lock } from 'lucide-react';

export const AiLocked = ({ title, requiredPlan = 'Elite or Career Success Pro' }) => (
  <Card className="p-8 text-center max-w-xl mx-auto border-2 border-dashed" data-testid="ai-locked-card">
    <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
      <Lock className="w-7 h-7 text-[#CE1126]" />
    </div>
    <h2 className="text-xl font-bold mb-2">{title} is locked</h2>
    <p className="text-sm text-gray-600 mb-5">
      This tool is part of the <strong>{requiredPlan}</strong> package. Upgrade to unlock it.
    </p>
    <Link to="/pricing"><Button className="btn-uae-red" data-testid="ai-locked-upgrade-btn">View Packages</Button></Link>
  </Card>
);

export default AiLocked;
